import type { Benefit } from '@/domain/Benefit';
import { api } from '@/lib/api';

export const createBenefitMutation = () => ({
  mutationFn: async (data: { text: string }) => {
    return await api
      .post('admin/ingredient-benefits', {
        json: data,
      })
      .json<Benefit>();
  },
});

export const deleteBenefitMutation = () => ({
  mutationFn: async (id: number) => {
    return await api.delete(`admin/ingredient-benefits/${id}`).json();
  },
});
